import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

export default function SignIn() {
  const { i18n } = useTranslation();
  useEffect(() => {
    window.location.replace(
      `${process.env.REACT_APP_AZURE_B2C_SIGN_IN_URL}&ui_locales=${i18n.language}`!
    );
  }, [i18n.language]);

  return <div></div>;
}
